// src/pages/Relatorios/RelatoriosPage.tsx

import AssessmentIcon from '@mui/icons-material/Assessment';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { ThemeProvider } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import QCXMainLayout from '../../../components/main-layout/QCXMainLayout';
import CardsModalGrid, { CardsModalGridItem } from '../../common/components/cardsGrid/cardsModalGrid';
import theme from '../../common/themes/theme';
import ProcessosAbertosAverbadosPage from './processosAbertosAverbados/processosAbertosAverbadosPage';
import ProcessosEmAndamentoPage from './processosEmAndamento/processosEmAndamentoPage';
import QuantidadeProcessosPage from './quantidadeProcessos/quantidadeProcessosPage';
import RelatorioPagamentosPage from './pagamentos/pagamentosPage';
import ProcessosExportacaoPage from './processosExportacao/processosExportacaoPage';
import KpiExportacaoPage from './kpiExportacao/kpiExportacaoPage';
const exportacaoModalGridItems: CardsModalGridItem[] = [
  {
    title: 'Processos Abertos e Averbados',
    icon: InsertDriveFileIcon,
    modalName: 'PROCESSOS_ABERTOS_AVERBADOS',
    modalComponent: ProcessosAbertosAverbadosPage,
  },
  {
    title: 'Relatório de Processos em Andamento',
    icon: InsertDriveFileIcon,
    modalName: 'PROCESSOS_EM_ANDAMENTO',
    modalComponent: ProcessosEmAndamentoPage,
  },
  {
    title: 'Quantidade de Processos Abertos e Registrados',
    icon: InsertDriveFileIcon,
    modalName: 'QUANTIDADE_PROCESSOS_ABERTOS_REGISTRADOS',
    modalComponent: QuantidadeProcessosPage,
  },
  {
    title: 'Relatório de Pagamentos',
    icon: InsertDriveFileIcon,
    modalName: 'RELATORIO_PAGAMENTOS',
    modalComponent: RelatorioPagamentosPage,
  },
  {
    title: 'Processos de Exportação',
    icon: InsertDriveFileIcon,
    modalName: 'PROCESSOS_DE_EXPORTACAO',
    modalComponent: ProcessosExportacaoPage,
  },
  {
    title: 'KPI Exportação',
    icon: InsertDriveFileIcon,
    modalName: 'KPI_EXPORTACAO',
    modalComponent: KpiExportacaoPage,
    requiredRoles: ['relatorio-kpi-exportacao-visualizar'],
  },
];

const ExportaçãoRelatoriosPage: React.FC = ({ authInfo = {} }: any) => {
  const { t } = useTranslation();

  const [reportOpenName, setReportOpenName] = useState('');
  const closeOpenReport = () => setReportOpenName('');
  const openReportByName = (name: string) => () => setReportOpenName(name);

  return (
    <ThemeProvider theme={theme}>
      <QCXMainLayout
        key="main-layout"
        pageTitle={'Relatórios de Exportação'}
        pageIcon={<AssessmentIcon color={'secondary'} />}
        breadcrumbs={[
          { link: { to: '/', name: t('com.muralis.qcx.inicio') } },
          { link: { to: '/exportacao', name: 'Exportação' } },
          { text: { name: 'Relatórios de Exportação' } },
        ]}
        authInfo={authInfo}
      >
        <CardsModalGrid
          items={exportacaoModalGridItems}
          modalOpenName={reportOpenName}
          openModalByName={openReportByName}
          closeModal={closeOpenReport}
        />
      </QCXMainLayout>
    </ThemeProvider>
  );
};

export default ExportaçãoRelatoriosPage;
